// Hook do uploadu pliku w panelu (np. logo Setup Wizard).
// POST /api/ui/core/panel/files/upload - body: { file_base64, file_name, mime_type }

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostUploadFileBody {
  file_base64: string;
  file_name?: string;
  mime_type?: string;
}

export interface IPostUploadFileResponse extends ICommandResponseSuccess {
  data?: { url: string };
  url?: string;
}

const postUploadFile = (data: IPostUploadFileBody): Promise<IPostUploadFileResponse> =>
  axios.post('/core/panel/files/upload', data);

export const usePostUploadFile = (
  options?: UseMutationOptions<IPostUploadFileResponse, IError, IPostUploadFileBody>
) => useMutation((data: IPostUploadFileBody) => postUploadFile(data), options);
